var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 163.287C130.475 163.287 163.287 130.475 163.287 90C163.287 49.5246 130.475 16.7129 90 16.7129C49.5246 16.7129 16.7129 49.5246 16.7129 90C16.7129 130.475 49.5246 163.287 90 163.287Z",
    fill: "#FFF8F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 150.826C123.593 150.826 150.826 123.593 150.826 90C150.826 56.4069 123.593 29.1743 90 29.1743C56.4069 29.1743 29.1743 56.4069 29.1743 90C29.1743 123.593 56.4069 150.826 90 150.826Z",
    fill: "#FFEEE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.853 78.5209L131.696 91.9005L131.282 94.4684C131.282 96.4567 127.034 122.649 124.834 122.649L90.0424 98.6089L51.4292 125.4C49.2299 125.4 46.9169 97.2141 46.9169 95.2259L46.7634 91.9005L46.1472 78.5599L52.3548 73.1959L87.5605 42.7728C88.2875 42.2624 89.1541 41.9885 90.0424 41.9885C90.9307 41.9885 91.7973 42.2624 92.5243 42.7728L127.697 73.1959L133.853 78.5209Z",
    fill: "#6A250B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.31 58.1135H56.0554V122.458H124.31V58.1135Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0474 113.531L46.1472 78.5598V138.012H133.853V78.5598L90.0474 113.531Z",
    fill: "#FC5719"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1472 78.5598V138.012L83.4629 108.286L46.1472 78.5598Z",
    fill: "#FEB295"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.853 78.5598V138.012L96.5371 108.286L133.853 78.5598Z",
    fill: "#FEB295"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1825 96.6236C97.0104 96.6236 102.545 91.0885 102.545 84.2606C102.545 77.4328 97.0104 71.8977 90.1825 71.8977C83.3547 71.8977 77.8196 77.4328 77.8196 84.2606C77.8196 91.0885 83.3547 96.6236 90.1825 96.6236Z",
    fill: "#FC5719"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1826 100.455C81.253 100.455 73.9883 93.1899 73.9883 84.2603C73.9883 75.3307 81.253 68.0659 90.1826 68.0659C99.1122 68.0659 106.377 75.3307 106.377 84.2603C106.377 93.1899 99.1122 100.455 90.1826 100.455ZM90.1826 69.8925C82.2602 69.8925 75.8148 76.3378 75.8148 84.2603C75.8148 92.1827 82.2602 98.6281 90.1826 98.6281C98.1051 98.6281 104.55 92.1827 104.55 84.2603C104.55 76.3378 98.1051 69.8925 90.1826 69.8925Z",
    fill: "#6A250B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3462 90.742L83.2 85.1669L85.5782 82.9716L88.1814 85.7917L94.6462 77.7791L97.1652 79.8114L88.3462 90.742Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMail);
export default __webpack_public_path__ + "static/media/check-mail.c48d2c9fef828a2d66a8f705157aeddf.svg";
export { ForwardRef as ReactComponent };